// Escolhe a área de detalhe da tela de Desembolso: a EAP do empreendimento ou o
// catálogo de insumos. Vivia dentro de `DisbursementList`, que saiu da tela — o
// seletor é da PÁGINA, não da lista.
const VIEWS = [
  { value: "node", label: "EAP" },
  { value: "resource", label: "Insumos" },
];

const DisbursementViewSwitch = ({ value, onChange }) => (
  <div className="ampli-disbursement-list__filters">
    <label className="ampli-disbursement-list__filter">
      <span>Filtrar por tipo de alvo</span>
      <select
        aria-label="Filtrar por tipo de alvo"
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
      >
        {VIEWS.map((view) => (
          <option key={view.value} value={view.value}>
            {view.label}
          </option>
        ))}
      </select>
    </label>
  </div>
);

export default DisbursementViewSwitch;
